module.exports = __webpack_public_path__ + "55850de16264742fe423c0edc780869c.svg";